import React from 'react'

export default function ReservationTitle() {
    return (
        <div className="row">
            <div className="col-sm-12">
                <h2 className="module-title font-alt align-left">Book a time</h2>
                <p className="module-subtitle font-serif align-left">For oil change, engine repair and detailing services, fill out the form below. We will contact you as soon as possible.</p>
            </div>
        </div>
    )
}
